import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'app-lease-list',
  templateUrl: './lease-list.component.html',
  styleUrl: './lease-list.component.scss'
})
export class LeaseListComponent {

  leases: any[] = [];
  totalLeases: number = 0;
  isLeaselistLoading: boolean = false;
  env = environment;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService,
  ) { }

  async getLeases(event?: TableLazyLoadEvent) {

    let limit = event?.rows || 10;
    let offset = event?.first || 0;

    let queryParams = {
      limit: limit,
      offset: offset,
      sortField: ((event?.sortField as string) || ''),
      sortOrder: (event?.sortOrder || 0)
    };

    this.isLeaselistLoading = true;
    let leasesResult: any = await this.trpcService.trpc.lease.getLeases.query(queryParams).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    this.leases = leasesResult;

    if (leasesResult) {
      let count: any = await this.trpcService.trpc.lease.getLeasesCount.query().catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
      this.totalLeases = count?.length ? count[0]['COUNT(*)'] : 0;
    }
    this.isLeaselistLoading = false;
  }

  getFileSize(size: any): string {
    let units = ['B', 'KB', 'MB']
    let bytes = size;
    let i = 0

    for (i; bytes > 1024; i++) {
      bytes /= 1024;
    }

    bytes = parseFloat(bytes.toFixed(2)) + ' ' + units[i]
    return bytes;
  }

}
